var exports = {
  "Nr": "x31de4314--ab89a8--card",
  "YB": "x31de4314--ab89a8--columns",
  "pB": "x31de4314--ab89a8--main-info",
  "VG": "x31de4314--ab89a8--title-block",
  "HU": "x31de4314--ab89a8--aside",
};

module.exports = exports;
